import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";

export const getHistory = (period) => dispatch => {
	dispatch({type : ACTIONS.BET.TOGGLE_FETCHING});

	Xhr.betHistory(period).then((resp) => dispatch({
		type : ACTIONS.BET.GET_HISTORY,
		data : resp.data,
	}));
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/bet.js